import { buildWizardPages } from "./wizardPages";

const pages = buildWizardPages();
const pageChild = (p) => ({
  key: `input-${p.id}`, label: p.short || p.title, title: p.title,
  path: `/planner?tab=inputs&page=${p.id}`, pageId: p.id, tab: "inputs",
});

/** Planner steps are grouped into a compact, ordered learning workflow. */
export const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: "Dashboard" },
  {
    key: "planner",
    label: "Schedule Planner",
    path: "/planner",
    icon: "CalendarMonth",
    children: [
      { key: "setup", label: "Plan setup", children: ["basics", "problem", "dtStage"].map((id) => pageChild(pages.find((p) => p.id === id))) },
      { key: "learning", label: "Learning path", children: ["systemDesign", "dsa", "subjects", "questions"].map((id) => pageChild(pages.find((p) => p.id === id))) },
      { key: "practice", label: "Assessment & practice", children: ["assessment", "banks"].map((id) => pageChild(pages.find((p) => p.id === id))) },
      { key: "schedule", label: "Schedule & review", children: ["dayActivities", "mustApply", "generate"].map((id) => pageChild(pages.find((p) => p.id === id))) },
      { key: "plans", label: "Plans", path: "/planner?tab=plans", tab: "plans" },
    ],
  },
  { key: "versions", label: "Version Management", path: "/versions", icon: "History" },
  { key: "logs",     label: "Maintain Logs",      path: "/logs",     icon: "HistoryEdu" },
  { key: "records",  label: "Record Management",  path: "/records",  icon: "FolderSpecialOutlined" },
];

// Routes that render without the Navbar/Sidebar shell (auth screens).
export const PUBLIC_ROUTES = ["/login", "/signup"];
